import  { post,get } from "./config"

//请求集中处理

//示例
/**
 * 
 * @param {*传入参数} p 
 * @param {*方法名称} getInfo
 * @returns 
 */

//登录
export const login = (p) => post("/user/login",p);

//验证token并返回用户信息
export const parseToken = (p) => get("/user/parseToken",p);

//发布文章或快讯
export const publishWK = (p) => post("/arctilce/publish",p);

//文章或快讯轮播图
export const getSlideshow = (p) => get("/carousel/getLbtInfo",p);

//分页查询文章、快讯信息
export const getArctilce = (p) => post("/arctilce/getArctilce",p);

//文章、快讯被浏览时
export const changReadNum = (p) => get("/arctilce/changeReadNum",p);

//获取文章详情
export const getWzById = (p) => get("/arctilce/getById",p);

//快讯热榜
export const getHotArcticle = (p) => get("/arctilce/getHotArcticle",p);

//资源上传
export const resourcesUpload = (p) => post("/resource/resourcesUpload",p);

//资源获取——所有
export const getResource = (p) => post("/resource/getResource",p);

//获取我的文章、快讯、资源
export const getMyArctilce = (p) => get("/arctilce/getMyArctilce",p);

//删除我的资源
export const delById = (p) => get("/arctilce/delById",p);

//资源下载、点击记录
export const changeNum = (p) => get("/resource/changeNum",p);

//获取资源详情
export const getResourceById = (p) => get("/resource/getResourceById",p);

//资源下载
export const downFile = (p) => get("/resource/downFile",p);

//获取用户剩余money
export const getById = (p) => get("/user/getById",p);

//判断资源是否已购买
export const isBuy = (p) => get("/ur/isBuy",p);

//购买资源
export const buyResource = (p) => get("/resource/buyResource",p);

//邮箱验证码
export const sendEmail = (p) => post("/register/sendEmail",p);

//注册
export const register = (p) => post("/user/register",p);

//充值
export const alipay = (p) => post("/pay/alipay",p);

//获取订单列表
export const getBill = (p) => get("/ur/getBill",p);

//修改用户信息或密码
export const changPwd = (p) => post("/user/changePwd",p);







